export default __webpack_public_path__ + "static/media/OmnigenWhiteOnly.fac4e983.svg";